<template>
  <div
    class="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-h-xl tw-h-screen tw-z-50"
  >
    <div
      class="tw-bg-black tw-bg-opacity-75 tw-fixed tw-inset-0"
      @click="$emit('close')"
    />

    <div class="tw-z-10 tw-w-full tw-max-w-4xl tw-mx-4">
      <div
        class="tw-bg-white tw-relative tw-shadow-md tw-rounded tw-px-16 tw-pt-6 tw-pb-6 tw-mb-4 tw-modal tw-h-screen tw-overflow-auto lg:tw-h-auto"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="tw-gray-500 hover:tw-gray-900 tw-size-6 tw-absolute tw-top-0 tw-right-0 tw-m-2 tw-cursor-pointer"
          @click="$emit('close')"
        >
          <path
            fill-rule="evenodd"
            d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
            clip-rule="evenodd"
          />
        </svg>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.body.classList.add('tw-overflow-hidden')
    document.body.classList.add('tw-relative')
    document.querySelector('html').classList.add('tw-overflow-hidden')
  },
  destroyed() {
    document.body.classList.remove('tw-overflow-hidden')
    document.body.classList.remove('tw-relative')
    document.querySelector('html').classList.remove('tw-overflow-hidden')
  },
}
</script>
